export default __webpack_public_path__ + "images/0x7f62ac1e974d65fab4a81821ca6af659a5f46298.png";